import React from 'react';

import Hero from './Hero';


function ProjectPage () {
    return (
        <>
          <Hero />
        </>
    );
}

export default ProjectPage;